import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthApi } from '../api/auth.api';
import { AuthCredentials } from '../models/auth.model';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly _api = inject(AuthApi);

  public login(data: AuthCredentials): Observable<User> {
    return this._api.login(data);
  }

  public logout(userId: number): Observable<void> {
    return this._api.logout(userId);
  }
}
